import { WIDGET_DEFAULT_FONT } from 'constants/fonts';

export const DEFAULT_HEIGHT_PX = 182.17;
export const DEFAULT_WIDTH_PX = 621;

export const DEFAULT_TABLE_DATA = {
  type: 'doc',
  content: [
    {
      type: 'table',
      content: [
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [295],
                backgroundColor: 'rgba(0, 82, 163, 1)',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'center',
                    fontSize: '16px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '16px',
                            color: 'rgb(255, 255, 255)',
                          },
                        },
                      ],
                      text: 'Milestone',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [93],
                backgroundColor: 'rgba(0, 82, 163, 1)',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'center',
                    fontSize: '16px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '16px',
                            color: 'rgb(255, 255, 255)',
                          },
                        },
                      ],
                      text: 'Status',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [120],
                backgroundColor: 'rgba(0, 82, 163, 1)',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'center',
                    fontSize: '16px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '16px',
                            color: 'rgb(255, 255, 255)',
                          },
                        },
                      ],
                      text: 'Expected',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [112],
                backgroundColor: 'rgba(0, 82, 163, 1)',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'center',
                    fontSize: '16px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '16px',
                            color: 'rgb(255, 255, 255)',
                          },
                        },
                      ],
                      text: 'Actual',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [295],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Server Cost and Performance Analysis',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [93],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Complete',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [120],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Week 3',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [112],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Week 2',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [295],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Electricity and Utility Infrastructure Upgrade',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [93],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'In Progress',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [120],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Week 20',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [112],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'TBD',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [295],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Materials Purchasing',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [93],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'In Progress',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [120],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Week 30',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [112],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'TBD',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [295],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Installation and Validation',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [93],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Not Started',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [120],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Week 38',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [112],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'TBD',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [295],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Implementation',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [93],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Not Started',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [120],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'Week 40',
                    },
                  ],
                },
              ],
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                rowspan: 1,
                colwidth: [112],
                backgroundColor: 'transparent',
                borderColor: 'rgba(204, 204, 204, 1)',
                borderWidth: '1px',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    lineHeight: '1.2',
                    textAlign: 'left',
                    fontSize: '12px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            fontFamily: WIDGET_DEFAULT_FONT,
                            fontSize: '12px',
                            color: 'rgba(43, 43, 53, 1)',
                          },
                        },
                      ],
                      text: 'TBD',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
